import script from "./supplier-inventory-picker.vue?vue&type=script&setup=true&lang=js"
export * from "./supplier-inventory-picker.vue?vue&type=script&setup=true&lang=js"

import "./supplier-inventory-picker.vue?vue&type=style&index=0&id=06f658ae&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06f658ae"]])

export default __exports__